export default {
    api_endpoint: "https://api.hatecrimetracker.1thing.org"
    //api_endpoint: "http://127.0.0.1:8081"
};